import '@styles/bmw.sass'

(() => {
    if (!document.body.classList.contains('page-template-template-guide')) return

    document.querySelectorAll<HTMLElement>('[data-guide-link]').forEach(link => {
        const video = link.querySelector('video')
        if (!video) return

        link.addEventListener("mouseenter", () => video.play().then(() => link.classList.add('is-playing')))
        link.addEventListener("mouseleave", () => {
            link.classList.remove('is-playing')
            setTimeout(() => {
                if (link.classList.contains('is-playing')) return
                video.pause()
                video.currentTime = 0
            }, 640)
        })
    })
})();